module.exports = __webpack_public_path__ + "static/img/yuqi-bg2.d502c8d9.png";